import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import { format } from 'date-fns'
import {ContentHeader,Loader} from '@components';
import {getActivityById} from '@app/services/activity';

const ViewActivity = () => {
  const params = useParams();
  const {id} = params;
  const [activityData, setActivityData] = useState([]);
  const [showLoader,setShowLoader] = useState(false)

  const getActivity = async () => {
    setShowLoader(true)
    const resp = await getActivityById(id);
    if (resp.data.ok === true) {
       
      setActivityData(resp.data.data);
    }
    setShowLoader(false)
  };

  useEffect(() => {
    getActivity();
  },[]);

  return (
    <div>
      <ContentHeader title="View Activity" path="/all-cases"/>
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">View Activity Page</h3>
            </div>
            <div className="card-body">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex align-items-baseline">
                    <h3 className="card-title">View Activity</h3>
                  </div>
                  <div className="card-body table-responsive p-0">
                  {showLoader ? (
                      <Loader title={'Daily'} />
                    ) : (
                    <table className="table table-hover text-nowrap">
                      <tbody>
                        <tr>
                          <th className="col-md-4">Date</th>
                          <th className="col-md-4">Activity</th>
                          <th className="col-md-4">Comment</th>
                          
                        </tr>
                        {activityData &&
                          activityData.map((val) => {
                            return (
                              <tr>
                                <td>{format(
                                      new Date(val.created_At),
                                      'dd MMMM, h:mm a'
                                    )}</td>
                                <td>{val.activityType}</td>
                                <td>
                                  {val.comment}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewActivity;
